module.exports = __webpack_public_path__ + "28cc313945218cc5abd7fa76b2dcc4cc.jpeg";